export type VolumeGroup = { title: string; items: string[] };
export type VolumeWorkout = { label: string; focus: string };
export type Volume = {
  number: string;
  title: string;
  color: string;
  meta?: string[];
  description?: string;
  workouts?: VolumeWorkout[];
  groups: VolumeGroup[];
  closing: string[];
};

export const volumes: Volume[] = [
  {
    number: "01",
    title: "Assessment, Safety & Coaching Foundations",
    color: "#1C2F4F",
    description: "Build a clear starting point before beginning the 40-week training system.",
    groups: [
      {
        title: "Includes",
        items: ["Training history", "Current activity level", "Training goals", "Exercise experience", "RPE", "Load selection", "Sets", "Reps", "Rest", "Fatigue", "Range of motion", "Balance", "Support needs"],
      },
    ],
    closing: ["Assess.", "Understand.", "Prepare."],
  },
  {
    number: "02",
    title: "First Trimester Training",
    color: "#4A7556",
    meta: ["Weeks 1–13", "39 Complete Workouts"],
    description: "3 sessions every week:",
    workouts: [
      { label: "Workout A", focus: "Full-Body Strength" },
      { label: "Workout B", focus: "Strength + Stability" },
      { label: "Workout C", focus: "Strength + Mobility / Low-Impact Conditioning" },
    ],
    groups: [
      {
        title: "Each workout includes",
        items: ["Exercises", "Sets", "Reps", "Rest", "Target RPE", "Coaching cues", "Regressions", "Progressions", "Practical modifications", "Home options", "Gym options"],
      },
    ],
    closing: ["Open.", "Coach.", "Track."],
  },
  {
    number: "03",
    title: "Second Trimester Training",
    color: "#1F6B73",
    meta: ["Weeks 14–27", "42 Complete Workouts"],
    groups: [
      { title: "Focus on adapting", items: ["Stance", "Range of Motion", "Abdominal Clearance", "Balance", "Starting Height", "Equipment Position", "External Support"] },
      { title: "Practical options for", items: ["Squats", "Hip Hinges", "Split Stance", "Pulling", "Pressing", "Core", "Carries", "Mobility", "Conditioning"] },
    ],
    closing: ["Maintain.", "Modify.", "Continue."],
  },
  {
    number: "04",
    title: "Third Trimester Training",
    color: "#B4676B",
    meta: ["Weeks 28–40", "39 Complete Workouts"],
    groups: [
      {
        title: "Includes",
        items: ["More supported exercise options", "Reduced-range variations", "Higher starting positions", "Different stance options", "Equipment-position changes", "Longer rest when needed", "Volume adjustments", "Reduced floor transitions", "More accessible setups"],
      },
    ],
    closing: ["Support.", "Simplify.", "Coach."],
  },
  {
    number: "05",
    title: "Exercise Adaptations & Real-World Coaching Solutions",
    color: "#2D3033",
    groups: [
      {
        title: "Quick-reference manual for situations where",
        items: ["Abdominal size affects the setup", "Balance changes", "Range changes", "Starting position becomes difficult", "More support is useful", "Floor access becomes inconvenient", "RPE increases", "Fatigue changes", "Equipment changes"],
      },
      { title: "Includes", items: ["Squat", "Hinge", "Split Stance", "Push", "Pull", "Glutes", "Core", "Cardio", "Mobility"] },
    ],
    closing: ["Identify.", "Modify.", "Coach."],
  },
];
